// this is an autogenerated file from App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/Settings/Content/Job/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_PaymentProviders_Accounts_Content_ProviderAccount_Settings_Content_Job_Content($account_id: String!) {
  payments_token_fee_eligibility_jobs(
    where: { account_id: { _eq: $account_id } }
    order_by: { created_at: desc }
    limit: 1
  ) {
    id
    status
    number_of_successful_tokens
    number_of_failed_tokens
    total_number_of_tokens
  }
}

`